import React from "react";
import PropTypes from "prop-types";
import styles from "./BillingItem.module.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faCcVisa,
  faCcMastercard,
  faCcDiscover,
  faCcDinersClub,
  faCcJcb,
} from "@fortawesome/free-brands-svg-icons";
import { ChevronRight } from "react-ikonate";
import { useTranslation } from "react-i18next";

const cardTypeToIcon = {
  visa: faCcVisa,
  mastercard: faCcMastercard,
  discover: faCcDiscover,
  "discover card": faCcDiscover,
  diners: faCcDinersClub,
  "diners club": faCcDinersClub,
  jcb: faCcJcb,
};

const getCardIcon = (type) => {
  if (!type) return null;
  const formattedCardType = type.toLowerCase().replace(/\s+/g, "");
  const iconKey = Object.keys(cardTypeToIcon).find((key) =>
    formattedCardType.includes(key.replace(/\s+/g, ""))
  );
  return iconKey ? cardTypeToIcon[iconKey] : null;
};

export function BillingItem({ info, onClick }) {
  const cardIcon = getCardIcon(info?.type);
  const {t} = useTranslation();

  return (
    <div className={info ? styles.container : styles.noInfoContainer}>
      <span className={styles.header}>{t("Primary Billing Payment Method")} </span>
      <div className={styles.cardInfo}>
        {info ? (
          <>
            {cardIcon && (
              <FontAwesomeIcon
                icon={cardIcon}
                className={styles.cardImage}
                alt={info.type}
              />
            )}
            <div className={styles.cardDetails}>
              <span className={styles.lastFour}>{t("Ending in")} {info.lastFour}</span>
              <div className={styles.chevron}>
                <ChevronRight
                  className={styles.dropdownArrow}
                  onClick={onClick}
                />
              </div>
            </div>
          </>
        ) : (
          <div className={styles.noBillingMethodMessage}>
            <div>{t("Please select a payment method")}</div>

            <div>
              <ChevronRight
                className={styles.dropdownArrow}
                onClick={onClick}
              />
            </div>
          </div>
        )}
      </div>
    </div>
  );
}

BillingItem.propTypes = {
  info: PropTypes.shape({
    type: PropTypes.string,
    lastFour: PropTypes.string,
  }),
  onClick: PropTypes.func,
};

export default BillingItem;
